import { Box, Text, HStack, useColorModeValue, Circle } from '@chakra-ui/react';
import { CustomCalendarIcon } from '../../../theme/icons/CustomCalendarIcon';
import { CustomPassesMultiIcon } from '../../../theme/multicolor-icons/CustomPassesMultiIcon';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MeContext } from '../../../context/MeContext';
import useEntityManagement from '../../../hooks/useEntitiesList';

const BatchItem = ({ batch, scheduled }) => {
  const modeSquareBgDark = useColorModeValue('#243744', 'white');
  const modeBoxBgDark = useColorModeValue('#243744', 'gradientBrand');
  const navigate = useNavigate();
  const meCtx = useContext(MeContext);
  const { entities } = meCtx.state;
  const { updateFilterEntity } = meCtx;
  const entitiesList = useEntityManagement(entities);

  const time = scheduled ? batch.scheduled_at : batch.completed_at;
  const recipients = batch.total_recipients;

  const getStatusColor = (status) => {
    switch (status) {
      case 'validating':
      case 'processing':
      case 'processed':
      case 'sending':
        return 'orange.500';
      case 'scheduled':
        return 'blue.500';
      case 'completed':
      case 'successful':
        return 'green.500';
      case 'failed':
      case 'partially_cancelled':
      case 'cancelled':
      case 'cancellation_failed':
      case 'completedWithErrors':
        return 'red.500';
      default:
        return 'gray.500';
    }
  };

  const handleClick = () => {
    const match = entitiesList.find(
      (opt) => opt.label !== 'All entities' && opt.value?.id === batch.entity_id
    );
    if (match) {
      updateFilterEntity(match.value);
    }
    navigate('/messaging');
  };

  return (
    <Box
      py={4}
      px={6}
      bg={modeBoxBgDark}
      borderRadius="10px"
      color="white"
      transition="transform 0.2s ease-in-out"
      _hover={{ transform: 'scale(1.02)' }}
      cursor="pointer"
      onClick={() => {
        handleClick();
      }}
    >
      <HStack justify="space-between">
        <Box>
          <Text fontWeight="600">{batch.name}</Text>
          <HStack justify="flex-start" gap={1}>
            <CustomCalendarIcon />
            <Text fontSize="sm">
              {scheduled ? 'Scheduled: ' : 'Sent: '}{' '}
              {moment(time).format('MM/DD/YYYY hh:mm A')}
            </Text>
          </HStack>
          <HStack justify="flex-start" gap={1}>
            <CustomPassesMultiIcon brand={true} boxSize="18px" />
            <Text fontSize="sm">Recipients: {recipients}</Text>
          </HStack>
        </Box>
        {scheduled === false && (
          <Circle size="20px" bg={getStatusColor(batch.status)} />
        )}
      </HStack>
    </Box>
  );
};

export default BatchItem;
